<template>
  <div class="wrap-phone" :class="type == 'top' && 'top'">
    <input type="text" v-model="phone" placeholder=" 请输入11位手机号码" />
    <div class="btn-use" @click="save()">免费试用</div>

    <div class="msg" v-show="msg_show">{{ msg }}</div>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      phone: "",
      msg: "",
      msg_show: false,
    };
  },
  methods: {
    save() {
      if (!this.phone) {
        return this.sendMsg("请输入");
      }
      if (
        !/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
          this.phone
        )
      ) {
        return this.sendMsg("请输入正确的手机号码");
      }

      let url = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API;
      window.$.post(
        url + "/api/contact/add",
        JSON.stringify({ contact: this.phone }),
        (res) => {
          if (res.code === 0) {
            this.sendMsg("发送成功");
            this.phone = "";
          } else {
            this.sendMsg(res.msg);
          }
        }
      );
    },
    sendMsg(m) {
      this.msg_show = true;
      this.msg = m;

      setTimeout(() => {
        this.msg_show = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.msg {
  position: fixed;
  z-index: 9999999;
  top: 20px;
  width: 200px;
  height: 40px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #666;
  padding: 0 20px;
  line-height: 40px;
  border-radius: 4px;
}

.wrap-phone {
  display: flex;
  justify-content: center;
}
.wrap-phone input {
  border: none;
  border-radius: 8px;
  background-color: #eee;
  color: #000;
  padding: 0 20px;
  outline: none;
  height: 40px;
  width: 240px;
}
.btn-use {
  height: 40px;
  width: 120px;
  line-height: 40px;
  text-align: center;
  background-color: #235ffa;
  color: #fff;
  border-radius: 8px;
  margin-left: 10px;
  cursor: pointer;
}
/*  */
.top input {
  background-color: #003fa7;
  opacity: 0.5;
  color: #fff;
}
.top .btn-use {
  background-color: #f6c946;
}
.top input::-webkit-input-placeholder {
  color: #fff;
}

/*  */
.mb .wrap-phone input {
  width: 180px;
}
</style>